import type { HostToIframeEvent } from './events'

export class MessageBus {
  constructor(private readonly getTargetWindow: () => Window | null) {}

  post(message: HostToIframeEvent) {
    const target = this.getTargetWindow()
    if (!target) return
    target.postMessage(message, '*')
  }
}